// extracted by mini-css-extract-plugin
export default {"noOutline":"qHQH1"};